/* import __COLOCATED_TEMPLATE__ from './change-bank-account-verification-success-modal.hbs'; */
import Component from '@ember/component';
export default class extends Component {}